
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Alert,
  Box,
  Chip,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { addUserRoots } from '../../../../../services/Users';
import { fetchActiveBranches } from '../../../../../services/dashboard/apiServiceDashboard';

const AddUserRootsForm = ({ userId, onSuccess }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState('');
  const [rootIds, setRootIds] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const data = await fetchActiveBranches();
        setBranches(data);
      } catch (error) {
        setMessage({ type: 'error', text: '❌ فشل في تحميل الفروع: ' + error.message });
      } finally {
        setLoading(false);
      }
    };
    loadBranches();
  }, []);

  const handleAddBranch = () => {
    const id = parseInt(selectedBranchId);
    if (!isNaN(id) && !rootIds.includes(id)) {
      setRootIds([...rootIds, id]);
    }
    setSelectedBranchId('');
  };

  const handleRemoveRootId = (idToRemove) => {
    setRootIds(rootIds.filter((id) => id !== idToRemove));
  };

  const handleConfirm = () => {
    setConfirmDialogOpen(true);
  };

  const handleCancelConfirm = () => {
    setConfirmDialogOpen(false);
  };

  const handleSubmitConfirmed = async () => {
    setMessage(null);
    try {
      await addUserRoots(userId, rootIds);
      setMessage({ type: 'success', text: '✅ تم ربط المستخدم بالفروع بنجاح' });
      if (onSuccess) onSuccess();
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setConfirmDialogOpen(false);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box component="form" onSubmit={(e) => { e.preventDefault(); handleConfirm(); }} sx={{ mt: 2 }}>
  
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <FormControl fullWidth>
          <InputLabel>اختر فرع</InputLabel>
          <Select
            value={selectedBranchId}
            label="اختر فرع"
            onChange={(e) => setSelectedBranchId(e.target.value)}
          >
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button onClick={handleAddBranch} disabled={!selectedBranchId}>
          إضافة
        </Button>
      </Box>

      <Box sx={{ mt: 2 }}>
        {rootIds.map((id) => {
          const branch = branches.find((b) => b.id === id);
          return (
            <Chip
              key={id}
              label={`فرع: ${branch?.name || id}`}
              onDelete={() => handleRemoveRootId(id)}
              sx={{ m: 0.5 }}
            />
          );
        })}
      </Box>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        disabled={rootIds.length === 0}
      >
        ربط المستخدم بالفروع
      </Button>

      {message && (
        <Alert severity={message.type} sx={{ mt: 2 }}>
          {message.text}
        </Alert>
      )}

      {/* Dialog التأكيد */}
      <Dialog open={confirmDialogOpen} onClose={handleCancelConfirm}>
        <DialogTitle>⚠️ تأكيد العملية</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            هل أنت متأكد أنك تريد ربط المستخدم بالفروع التالية؟
          </Typography>
          <ul style={{ paddingRight: '1rem' }}>
            {rootIds.map((id) => {
              const branch = branches.find((b) => b.id === id);
              return (
                <li key={id}>
                  {branch?.name || `فرع ${id}`}
                </li>
              );
            })}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirm}>لا</Button>
          <Button onClick={handleSubmitConfirmed} color="primary" variant="contained">
            نعم، نفّذ
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddUserRootsForm;
